import React, { useState } from "react";
import {
  CollapseClose,
  CollapseCloseWhiteIcon,
  CollapseOpen,
  CollapseOpenWhiteIcon,
  RedErrorIcon,
} from "../../../assets/images";
import GstTableHeader from "../common/GstTableHeader";
import { GSTR_INVOICE2B_HEADER } from "../../../constant/tableHeadersConstants/gst";
import { formateDateWithTime } from "../../../utils/commonFunctions";
import CustomizedAvatar from "../../commons/CircularAvatar/CustomizedAvatar";
import GstrTwoBTableData from "../common/GstTwoBTableData";

type AppProps = {
  data: any;
  type: string;
  setData: any;
  showMissingInvoices: boolean;
  handleCompareAddInvoice: (data: string,month:string) => void;
};
const GstrTwo2BAccordian = ({
  data,
  type,
  setData,
  showMissingInvoices,
  handleCompareAddInvoice,
}: AppProps) => {
  const handleToggleAccordianClick = (id: any) => {
    data?.map((elem: any) => {
      if (elem?.month_name === id) {
        elem.isOpen = !elem?.isOpen;
      }
    });
    setData([...data]);
  };

  const handleData = (invoice: any, index: number, allData: any) => {
    return (
      <>
        {!invoice?.is_error_occured ? (
          <>
            {invoice?.gstr2B_documents_details ? (
              <div className="row col-md-12 p-3">
                <span
                  style={{
                    color: "#6e7491",
                    fontSize: "15px",
                    fontWeight: 600,
                  }}
                >
                  Data Last Fetched On:&nbsp;
                </span>
                <span style={{ fontWeight: 700 }}>
                  {formateDateWithTime(
                    invoice?.gstr2B_documents_details?.gstr_2B_fetched_date
                  )}
                </span>

                <span
                  className="ml-3"
                  style={{
                    color: "#6e7491",
                    fontSize: "15px",
                    fontWeight: 600,
                  }}
                >
                  Data Last Fetched By:&nbsp;
                </span>
                <span>
                  <CustomizedAvatar
                    name={
                      invoice?.gstr2B_documents_details?.gstr_2B_fetched_by
                        ?.first_name +
                      " " +
                      invoice?.gstr2B_documents_details?.gstr_2B_fetched_by
                        ?.last_name
                    }
                    image={
                      invoice?.gstr2B_documents_details?.gstr_2B_fetched_by
                        ?.profile_pic?.file_url
                    }
                  />
                </span>
                <span className="ml-2">
                  {
                    invoice?.gstr2B_documents_details?.gstr_2B_fetched_by
                      ?.first_name
                  }{" "}
                  {
                    invoice?.gstr2B_documents_details?.gstr_2B_fetched_by
                      ?.last_name
                  }
                </span>
              </div>
            ) : (
              ""
            )}
            <div className="table-responsive gstr">
              <table className="table">
                <thead
                  className="sticky-table-header thead-light"
                  style={{ zIndex: 0 }}
                >
                  <GstTableHeader tableHeader={GSTR_INVOICE2B_HEADER} />
                </thead>

                <tbody>
                  <GstrTwoBTableData
                    data={invoice}
                    tableHeader={GSTR_INVOICE2B_HEADER}
                    setData={setData}
                    finalData={allData}
                    index={index}
                    showMissingInvoices={showMissingInvoices}
                    handleCompareAddInvoice={handleCompareAddInvoice}
                  />
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div
            className="mt-2 mb-2 error-msg p-2"
            style={{
              border: "1px solid #ba4916",
              backgroundColor: "#fef2ed",
              borderRadius: "6px",
              width: "fit-content",
              margin: "auto",
            }}
          >
            <span className="mr-1">
              <img src={RedErrorIcon} alt="error" />
            </span>
            <span>
              {invoice?.data?.error?.error_cd}: {invoice?.data?.error?.message}
            </span>
          </div>
        )}
      </>
    );
  };
  return (
    <>
      {data?.map((item: any, index: number) => {
        return (
          <div className="col-md-12">
            <>
              <div className="accordian">
                <>
                  {item.isOpen ? (
                    <img
                      width="20px"
                      onClick={() =>
                        handleToggleAccordianClick(item.month_name)
                      }
                      style={{ cursor: "pointer" }}
                      src={type ? CollapseOpenWhiteIcon : CollapseOpen}
                      className="accordion-arrow"
                      alt="accordion-arrow"
                    />
                  ) : (
                    <img
                      width="20px"
                      onClick={() =>
                        handleToggleAccordianClick(item.month_name)
                      }
                      style={{ cursor: "pointer" }}
                      src={type ? CollapseCloseWhiteIcon : CollapseClose}
                      className="accordion-arrow"
                      alt="accordion-arrow"
                    />
                  )}
                </>

                {item?.month_name}
              </div>

              {item.isOpen && <div>{handleData(item, index, data)}</div>}
            </>
          </div>
        );
      })}
    </>
  );
};

export default GstrTwo2BAccordian;
